<template>
      <v-card class="mx-auto" shaped elevation="7" min-height="700px">
            <v-card-title>
                  Informe Liquidación Comisión Prima
                  <!-- <ModalInformeLiquidacionComponent :open="obModal.openModal" :obModal="obModal" :parametros="parametros" :listGeneral="listGeneral"/> -->
            </v-card-title>
            <v-card-text>
                  <v-container fluid grid-list-md>
                        <v-form ref="form">

                              <v-row dense>
                                    <v-col cols="12" sm="4">
                                          <v-autocomplete label="Canal *" color="textbox" v-model="obSearch.idCanal"
                                                :items="listGeneral.listCanal" item-text="canal" item-value="idCanal" outlined
                                                dense :rules="requeridoRegla" @change="onListarAseguradora" />
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                          <v-autocomplete label="Aseguradora *" color="textbox"
                                                v-model="obSearch.idAseguradora" :items="listGeneral.listAseguradora" outlined
                                                dense @change="onListarSeguro" :rules="requeridoRegla" />
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                          <v-autocomplete label="Seguro *" color="textbox" v-model="obSearch.idSeguro"
                                                :items="listGeneral.listSeguro" outlined dense @change="onListarProducto"
                                                :rules="requeridoRegla" />
                                    </v-col>
                              </v-row>

                              <v-row dense>
                                    <v-col cols="12" sm="4">
                                          <v-autocomplete label="Producto *" color="textbox" v-model="obSearch.idProducto"
                                                :items="listGeneral.listProducto" outlined dense :rules="requeridoRegla" />
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                          <v-dialog ref="dialogFechaDesde" v-model="objDate.desde.abrirModal"
                                                :return-value.sync="obSearch.fechaInicioCorte" persistent width="340px">
                                                <template v-slot:activator="{ on }">
                                                      <v-text-field color="textbox" v-model="obSearch.fechaInicioCorte"
                                                            label="Fecha Desde *" prepend-inner-icon="event" readonly outlined
                                                            dense v-on="on" :rules="requeridoRegla" />
                                                </template>
                                                <v-date-picker color="primary" v-model="obSearch.fechaInicioCorte" scrollable
                                                      locale="es">
                                                      <v-spacer></v-spacer>
                                                      <v-btn outlined dense rounded color="danger"
                                                            @click="objDate.desde.abrirModal = false" v-html="'Salir'">
                                                      </v-btn>
                                                      <v-btn rounded dark color="primary"
                                                            @click="$refs.dialogFechaDesde.save(obSearch.fechaInicioCorte);"
                                                            v-html="'Guardar Fecha'"></v-btn>
                                                </v-date-picker>
                                          </v-dialog>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                          <v-dialog ref="dialogFechaHasta" v-model="objDate.hasta.abrirModal"
                                                :return-value.sync="obSearch.fechaFinCorte" persistent width="340px">
                                                <template v-slot:activator="{ on }">
                                                      <v-text-field color="textbox" v-model="obSearch.fechaFinCorte"
                                                            label="Fecha Hasta *" prepend-inner-icon="event" readonly outlined
                                                            dense v-on="on" :rules="requeridoRegla" />
                                                </template>
                                                <v-date-picker color="primary" v-model="obSearch.fechaFinCorte" scrollable
                                                      locale="es">
                                                      <v-spacer></v-spacer>
                                                      <v-btn outlined dense rounded color="danger"
                                                            @click="objDate.hasta.abrirModal = false" v-html="'Salir'">
                                                      </v-btn>
                                                      <v-btn rounded dark color="primary"
                                                            @click="$refs.dialogFechaHasta.save(obSearch.fechaFinCorte);"
                                                            v-html="'Guardar Fecha'"></v-btn>
                                                </v-date-picker>
                                          </v-dialog>
                                    </v-col>
                              </v-row>
                        </v-form>

                        <v-row dense>
                              <v-col cols="12" sm="4" />
                              <v-col cols="12" sm="4" />
                              <v-col cols="12" sm="4" class="text-right">
                                    <v-tooltip top color="primary">
                                          <template v-slot:activator="{ on }">
                                                <v-btn fab dark small color="primary" @click="onListar" v-on="on"
                                                      :disabled="disabled">
                                                      <v-icon dark>search</v-icon>
                                                </v-btn>
                                          </template>
                                          <span>Buscar</span>
                                    </v-tooltip>
                              </v-col>
                        </v-row>

                        <v-row dense>
                              <v-col v-if="_.size(listGeneral.detalle) == 0" cols="12" sm="6"/>
                              <v-col v-else cols="12" sm="6">
                                    <v-btn rounded color="primary" dark @click="exportar('tableInfLiqCom','Informe de Liquidación Comisión Prima')">Exportar a XLSX</v-btn>
                              </v-col>
                              <v-col cols="12" sm="6">
                                    <v-text-field label="Buscar" color="textbox" v-model="obSearch.search" clearable
                                          dense prepend-inner-icon="search" />
                              </v-col>
                        </v-row>
                        <v-row dense>
                              <v-col cols="12">
                                    <v-data-table :search="obSearch.search" :headers="listGeneral.cabecera" 
                                          :items="listGeneral.detalle" class="elevation-3" id="tableInfLiqCom">
                                          
                                          <template v-slot:item.name="{ item }">
                                                <v-btn class="ma-2" text icon color="primary" @click="view(item)">
                                                      <v-icon small>visibility</v-icon>
                                                </v-btn>
                                          </template>

                                          <template v-slot:no-results>
                                                Tu búsqueda de "<span v-html="obSearch.search"></span>" no arrojó
                                                resultados.
                                          </template>
                                    </v-data-table>
                              </v-col>
                        </v-row>

                        <v-row dense >
                            <v-col cols="12">
                                <modalPdfComponent :mostrar="objPdf.mostrar" :base64="objPdf.base64" :titulo="objPdf.titulo"/>
                            </v-col>
                        </v-row>

                  </v-container>
            </v-card-text>
      </v-card>
</template>

<script>
      export default {
            name: 'InformeLiquidacionComisionView',
            components:{
                  modalPdfComponent: () => import('@/components/utilites/modalComponent.vue')
            },
            data: () => ({
                  objDate: {
                              desde: {
                                    abrirModal: false
                              },
                              hasta: {
                                    abrirModal: false
                              },
                        },
                  obSearch: {
                        search: '',
                        fechaInicioCorte: moment().format('YYYY-MM-DD'),
                        fechaFinCorte: moment().format('YYYY-MM-DD'),
                        idAseguradora: null,
                        idSeguro: null,
                        idCanal: null,
                        idProducto: null
                  },
                  objPdf:{
                        mostrar: false,
                        base64: '',
                        titulo: ''
                  },
                  listGeneral: {},
                  parametros: {},
                  disabled: false
            }),
            created() {
                  var error = 'E';

                  axios.post(`${BASE_URI}administrador/informe-liquidacion-comision/cargaGeneral`)
                        .then((r) => {
                              if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                              if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion); }
                                    this.$set(this, 'listGeneral', r.data.data.listas);
                                    this.$set(this, 'parametros', r.data.data.parametros);
                                    this.obSearch.idCanal = this.listGeneral.listCanal[0].idCanal;
                                    return this.onListarAseguradora('L');
                        })
                        .catch((e) => {
                              mensajesAlerta(e, error);
                        })
            },
            methods: {
                  onListarAseguradora(ev){
                        if (!_.isUndefined(ev)) {
                              var error = 'E';
                              var o = _.merge({
                                          opcion: 'LISTAR_ASEGURADORA_X_CANAL'
                                    },
                                    _.pick(this.obSearch, 'idCanal')
                              );

                              this.listGeneral.listAseguradora = [];
                              axios.post(`${BASE_URI}administrador/poliza/listar`, o)
                                    .then((r) => {
                                          if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                                          if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion); }
                                                
                                                var l = _.cloneDeep(r.data.data);
                                                _.map(l,(v)=>{
                                                      this.listGeneral.listAseguradora.push({
                                                            value:v.idAseguradora,
                                                            text:v.aseguradora
                                                      });
                                                      return v;
                                                });
                                    })
                                    .catch((e) => {
                                          mensajesAlerta(e, error);
                                    });
                        }
                  },
                  onListarSeguro(ev) {
                        if (!_.isUndefined(ev)) {
                              var error = 'E';
                              var o = {
                                          opcion: 'LISTAR_SEGURO_X_ASEGURADORA_CANAL',
                                          idCanal: _.toNumber(this.obSearch.idCanal) == 0 ? '' : this.obSearch.idCanal,
                                          idAseguradora: _.toNumber(this.obSearch.idAseguradora) == 0 ? '' : this.obSearch.idAseguradora
                                    };

                              this.listGeneral.listSeguro = [];
                              axios.post(`${BASE_URI}administrador/poliza/listar`, o)
                                    .then((r) => {
                                          if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                                          if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion); }

                                                this.listGeneral.listSeguro.push({text:'Todos',value:'0'});
                                                var l = _.cloneDeep(r.data.data);
                                                _.map(l,(v)=>{
                                                      this.listGeneral.listSeguro.push({
                                                            value:v.idSeguro,
                                                            text:v.seguro
                                                      });
                                                      return v;
                                                });
                                    })
                                    .catch((e) => {
                                          mensajesAlerta(e, error);
                                    });
                        }
                  },
                  onListarProducto(ev) {
                        if (!_.isUndefined(ev)) {
                              var error = 'E';
                              var o = {
                                          opcion: 'LISTARCOMBO',
                                          idAseguradora: _.toNumber(this.obSearch.idAseguradora) == 0 ? null : this.obSearch.idAseguradora,
                                          idSeguro: _.toNumber(this.obSearch.idSeguro) == 0 ? null : this.obSearch.idSeguro,
                                    };

                              this.listGeneral.listProducto = [];
                              axios.post(`${BASE_URI}administrador/producto/listar`, o)
                                    .then((r) => {
                                          if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                                          if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion); }

                                          this.listGeneral.listProducto.push({text:'Todos',value:'0'});
                                                var l = _.cloneDeep(r.data.data);
                                                _.map(l,(v)=>{
                                                      this.listGeneral.listProducto.push({
                                                            value:v.id_producto,
                                                            text:v.nombre_producto
                                                      });
                                                      return v;
                                                });
                                    })
                                    .catch((e) => {
                                          mensajesAlerta(e, error);
                                    });
                        }
                  },
                  onListar(ev) {
                        if (!_.isUndefined(ev)) {
                              try {
                                    this.disabled = true;
                                    if (!this.$refs.form.validate()) throw mensajeEstandar.corregirInformacion;
                                    var error = 'E';
                                    var o = _.merge({
                                                opcion: 'LISTAR',
                                                idProducto: _.toNumber(this.obSearch.idProducto) == 0 ? null : this.obSearch.idProducto
                                          },
                                          _.pick(this.obSearch, ['fechaInicioCorte','fechaFinCorte']),
                                    );

                                    this.listGeneral.detalle = [];
                                    axios.post(`${BASE_URI}administrador/informe-liquidacion-comision/listar`, o)
                                          .then((r) => {
                                                if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                                                if (_.size(_.get(r, ['data', 'data'], [])) == 0) {
                                                      error = 'I';
                                                      throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion);
                                                }

                                                this.listGeneral.detalle = r.data.data;
                                                this.disabled = false;
                                          })
                                          .catch((e) => {
                                                mensajesAlerta(e, error);
                                                this.disabled = false;
                                          });
                              } catch (ex) {
                                    mensajesAlerta(ex, 'I');
                                    this.disabled = false;
                              }
                        }
                  },
                  view(v){
                        var error = 'E';
                        
                        axios.post(`${BASE_URI}administrador/repository-file/listar`,{'path': v.path})
                         .then((r) => {
                             if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                             if(_.size(_.get(r,['data','data'],[])) == 0) { error= 'I'; throw 'Error al leer el archivo PDF.'; } 
                                 this.objPdf.base64 = JSON.parse(JSON.stringify(r.data.data));
                                 this.objPdf.titulo = 'Informe de Liquidación Comisión';
                                 this.objPdf.mostrar = true;
                         })
                         .catch((e) => {
                             mensajesAlerta(e,error);
                         });
                  },
                  cerrarModalPdf(){
                        this.objPdf.mostrar =  false;
                        this.objPdf.base64 = '';
                  }
            },
            provide(){
                  return{
                        cerrarModalPdf: this.cerrarModalPdf
                  }
            }
      }
</script>